// Passwords, the refresh token, the reCAPTCHA token and bank details all went out
// verbatim before this, because the request body is attached to every API report.
const SENSITIVE_KEY = /pass(word)?|token|secret|recaptcha|iban/i;

export const REDACTED = '[redacted]';

const redact = (value) => {
  if (Array.isArray(value)) {
    return value.map(redact);
  }

  // Plain objects only: FormData, Blob or Date would come out as {} and lose what they said.
  if (Object.prototype.toString.call(value) === '[object Object]') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, SENSITIVE_KEY.test(key) ? REDACTED : redact(item)]),
    );
  }

  return value;
};

/**
 * @description Strip credentials from request params before they are sent to Bugsnag.
 *
 * axios hands over `config.data` already serialised, so a JSON string is parsed,
 * redacted and serialised again. Any other string cannot be inspected key by key
 * and is kept only when it carries nothing that looks sensitive.
 * @param params `config.params` or `config.data` of the failed request
 * @returns {*}
 */
export const redactParams = (params) => {
  if (typeof params !== 'string') {
    return redact(params);
  }

  try {
    return JSON.stringify(redact(JSON.parse(params)));
  } catch (e) {
    return SENSITIVE_KEY.test(params) ? REDACTED : params;
  }
};

export default redactParams;
